import React, { useState, useEffect } from "react";
import type { Template } from "../constants";
import styles from "../../../../styles/mailCenter/templatePreviewModal.module.scss";


type ViewMode = "Desktop View" | "Mobile View";

interface TemplatePreviewModalProps {
  template: Template | null;
  onClose:  () => void;
}

const TemplatePreviewModal: React.FC<TemplatePreviewModalProps> = ({
  template,
  onClose,
}) => {
  const [viewMode, setViewMode] = useState<ViewMode>("Desktop View");

  useEffect(() => {
    if (!template) return;
    const handler = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [template, onClose]);

  // Reset view mode when a new template opens
  useEffect(() => {
    if (template) setViewMode("Desktop View");
  }, [template]);

  if (!template) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  const frameModifier =
    viewMode === "Desktop View"
      ? styles["modal__frame--desktop"]
      : styles["modal__frame--mobile"];

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>

        {/* Header */}
        <div className={styles["modal__header"]}>
          <h2 className={styles["modal__title"]}>Mail Preview</h2>
          <button
            className={styles["modal__close-btn"]}
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Desktop / Mobile toggle */}
        <div className={styles["modal__toggle"]}>
          {(["Desktop View", "Mobile View"] as ViewMode[]).map((mode) => (
            <button
              key={mode}
              onClick={() => setViewMode(mode)}
              className={[
                styles["modal__toggle-btn"],
                viewMode === mode ? styles["modal__toggle-btn--active"] : "",
              ].join(" ")}
            >
              {mode}
            </button>
          ))}
        </div>

        {/* Email preview body */}
        <div className={styles["modal__body"]}>
          <div className={`${styles["modal__frame"]} ${frameModifier}`}>
            <p className={styles["modal__subject-label"]}>Subject Line</p>
            <h3 className={styles["modal__subject-text"]}>{template?.subject}</h3>
            <hr className={styles["modal__divider"]} />
            {/* <p className={styles["modal__body-text"]}>{template?.body}</p> */}
            <div 
            className={styles["modal__body-text"]}
            dangerouslySetInnerHTML={{ __html: template?.body }}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default TemplatePreviewModal;